import PropTypes from 'prop-types'
import React, { Component, createRef } from 'react'
import focusable from '../../components/Focusable/Focusable'
import { noOp } from '../../../../shared/helpers'

class FocusableInput extends Component {
  constructor(props) {
    super(props)
    this.componentType = this.props.componentType
    this.inputRef = createRef()
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.hasFocus && this.props.hasFocus) {
      this.inputRef.current.focus({ focusVisible: true })
      this.props.onFocused && this.props.onFocused()
    }
  }

  onKeyEvent(key) {
    const { hasFocus, disabled } = this.props
    if (key === 'ENTER' && hasFocus && !disabled) {
      this.inputRef.current?.click()
      return true
    }
    return false
  }

  render() {
    const { onClick, className, hasFocus, value } = this.props
    return (
      <div
        ref={this.inputRef}
        onClick={onClick}
        className={`focusable-input ${
          hasFocus ? 'focusable-input--focused' : ''
        } ${className}`}
      >
        <p>{value} </p>
        {hasFocus && <p className="fake-cursor">|</p>}
      </div>
    )
  }
}

FocusableInput.propTypes = {
  onClick: PropTypes.func,
  onFocused: PropTypes.func,
  className: PropTypes.string,
  hasFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  componentType: PropTypes.string,
  value: PropTypes.string,
}

FocusableInput.defaultProps = {
  children: null,
  onClick: noOp,
  onFocused: noOp,
  className: '',
  hasFocus: false,
  disabled: false,
}

export default focusable(FocusableInput)
